import { Component, OnInit, EventEmitter, Output } from '@angular/core';
import { environment } from '../../../environments/environment';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { ApiService } from '../../services/api.service';
import { ToastrService } from 'ngx-toastr';
import { ParaderoListItemDTO } from '../../../dtos/response/getListaParaderos.response.dto';
import { debounceTime, distinctUntilChanged, Subject } from 'rxjs';
import { HttpErrorResponse } from '@angular/common/http';
import { BsModalRef } from 'ngx-bootstrap/modal';
import moment from 'moment';
import { EventService } from '../../services/event.service';
import { GetListaServiciosV3ResponseDTO } from '../../../dtos/response/getListaServiciosV3.response.dto';
import { ServicioV3DTO } from '../../../dtos/servicioV3.dto';
import { NgSelectModule } from '@ng-select/ng-select';
import { SucursalDTO } from '../../../dtos/sucursal.dto';
import { GetListaSucursalesResponseDTO } from '../../../dtos/response/getListaSucursales.response.dto';

@Component({
  selector: 'app-modal-crear-viaje',
  standalone: true,
  imports: [CommonModule, FormsModule, NgSelectModule],
  templateUrl: './modal-crear-viaje.component.html',
  styleUrl: './modal-crear-viaje.component.scss'
})
export class ModalCrearViajeComponent implements OnInit {
  // Trip type
  tripTypes = {
    COMERCIAL: 'VIAJE COMERCIAL',
    NO_COMERCIAL: 'VIAJE NO COMERCIAL',
    ESPECIAL: 'VIAJE ESPECIAL'
  };
  selectedTripType: string = this.tripTypes.ESPECIAL; // Default to ESPECIAL since it's visible in the HTML

  // Paraderos data
  paraderos: ParaderoListItemDTO[] = [];
  filteredParaderos: ParaderoListItemDTO[] = [];
  loading = false;

  // Selected values
  origenUuid: string = '';
  destinoUuid: string = '';

  // Search text
  searchText: string = '';
  private searchTextChanged = new Subject<string>();

  // Form data
  fechaInicio: string = moment().format('YYYY-MM-DD');
  horaInicio: string = '08:00';
  horaTermino: string = '10:00';
  sentido: string = 'IDA'; // Default direction

  // Direction options
  direcciones = ['IDA', 'VUELTA'];

  // Event to close the modal
  @Output() closeModal = new EventEmitter<boolean>();

  //Parámetros viaje --V3--
  public listaServiciosV3: ServicioV3DTO[];
  public servicioV3Seleccionado: ServicioV3DTO;
  public listaSucursales: Array<SucursalDTO> = [];
  terminalDestinoV3Seleccionado: SucursalDTO;
  terminalOrigenV3Seleccionado: SucursalDTO;

  public fechas: { [key: string]: string } = {
    fechaSalidaTerminalV3: moment().format('YYYY-MM-DD'),
    fechaInicioViajeV3: moment().format('YYYY-MM-DD'),
    fechaTerminoViajeV3: moment().format('YYYY-MM-DD'),
    fechaLlegadaTerminalV3: moment().format('YYYY-MM-DD'),
  };

  public horas: { [key: string]: string } = {
    horaSalidaTerminalV3: moment().format('HH:mm'),
    horaInicioViajeV3: moment().format('HH:mm'),
    horaTerminoViajeV3: moment().format('HH:mm'),
    horaLlegadaTerminalV3: moment().format('HH:mm'),
  };

  constructor(
    private apiService: ApiService,
    public bsModalRef: BsModalRef,
    public eventService: EventService,
    private toastr: ToastrService
  ) {
    // Setup search debounce
    this.searchTextChanged.pipe(
      debounceTime(300),
      distinctUntilChanged()
    ).subscribe(text => {
      this.searchParaderos(text);
    });
  }

  ngOnInit(): void {
    // Load initial paraderos
    this.loadParaderos();

    //--V3--
    this.getListaServiciosV3();
    this.getListaSucursales();

  }

  getListaServiciosV3() {

    this.apiService.getListaServiciosV3().
      subscribe((resp) => this.getListaServiciosSuccessV3(resp), (error) => this.getListaServicioErrorV3(error));

  }

  getListaServiciosSuccessV3(getListaServiciosV3ResponseDTO: GetListaServiciosV3ResponseDTO) {
    this.listaServiciosV3 = getListaServiciosV3ResponseDTO.data.list;
  }

  getListaServicioErrorV3(error: HttpErrorResponse) {
    this.toastr.error((error.error?.msg || '') + (error['requestId'] ? ' Code: ' + error['requestId'] : ''), 'Error', { timeOut: environment.toastErrorTimeout, extendedTimeOut: environment.toastErrorTimeout, closeButton: true, tapToDismiss: false });
  }

  getListaSucursales() {
    this.apiService.getListaSucursales().subscribe((resp) => this.getListaSucursalesSuccess(resp), (error) => this.getListaSucursalesError(error));
  }

  getListaSucursalesSuccess(getListaSucursalesResponseDTO: GetListaSucursalesResponseDTO) {
    console.log('exito get sucursales', getListaSucursalesResponseDTO);
    this.listaSucursales = getListaSucursalesResponseDTO.data;
  }

  getListaSucursalesError(error: HttpErrorResponse) {
    console.log('error get sucursales', error);
    this.toastr.error((error.error?.msg || '') + (error['requestId'] ? ' Code: ' + error['requestId'] : ''), 'Error', { timeOut: environment.toastErrorTimeout, extendedTimeOut: environment.toastErrorTimeout, closeButton: true, tapToDismiss: false });
  }

  formatearTiempo(event: any, campo: string) {
    const input = event.target;
    let value = input.value;
    const isBackspace = event.inputType === 'deleteContentBackward';

    value = value.replace(/[^0-9]/g, '');
    if (value.length > 4) value = value.slice(0, 4);
    if (value.length >= 3) {
      value = value.slice(0, 2) + ':' + value.slice(2);
    } else if (value.length >= 2 && !isBackspace) {
      value = value.slice(0, 2) + ':';
    }

    input.value = value;
    if (!isBackspace && value.length === 3 && value.includes(':')) {
      input.setSelectionRange(3, 3);
    }

    this.horas[campo] = value;
  }

  normalizarCampoHora(campo: string) {
    this.horas[campo] = this.normalizarHora(this.horas[campo]);
  }

  normalizarHora(hora: string): string {
    let value = hora.replace(/[^0-9]/g, '');

    if (value.length === 1) return `0${value}:00`;
    if (value.length === 2) return `${value}:00`;
    if (value.length === 3) return `${value.slice(0, 2)}:${value.slice(2)}0`;
    if (value.length === 4) return `${value.slice(0, 2)}:${value.slice(2)}`;
    return '00:00';
  }

  crearViajeComercialV3(): void {

    //this.enviando = true;

    const fechaHoraSalidaTerminalV3 = moment(this.fechas['fechaSalidaTerminalV3'] + " " + this.horas['horaSalidaTerminalV3'], 'YYYY-MM-DD HH:mm').format('YYYY-MM-DDTHH:mm:ss');
    const fechaHoraInicioViajeV3 = moment(this.fechas['fechaInicioViajeV3'] + " " + this.horas['horaInicioViajeV3'], 'YYYY-MM-DD HH:mm').format('YYYY-MM-DDTHH:mm:ss');
    const fechaHoraTerminoViajeV3 = moment(this.fechas['fechaTerminoViajeV3'] + " " + this.horas['horaTerminoViajeV3'], 'YYYY-MM-DD HH:mm').format('YYYY-MM-DDTHH:mm:ss');
    const fechaHoraLlegadaTerminalV3 = moment(this.fechas['fechaLlegadaTerminalV3'] + " " + this.horas['horaLlegadaTerminalV3'], 'YYYY-MM-DD HH:mm').format('YYYY-MM-DDTHH:mm:ss');

    const sucursalOrigenUuid = this.terminalOrigenV3Seleccionado?.uuid ? this.terminalOrigenV3Seleccionado.uuid : '';
    const sucursalDestinoUuid = this.terminalDestinoV3Seleccionado?.uuid ? this.terminalDestinoV3Seleccionado.uuid : '';

    const servicioV3Uuid = this.servicioV3Seleccionado?.uuid ? this.servicioV3Seleccionado.uuid : '';

    this.apiService.putCrearViajeComercialV3Despachador(
      fechaHoraSalidaTerminalV3,
      fechaHoraInicioViajeV3,
      fechaHoraTerminoViajeV3,
      fechaHoraLlegadaTerminalV3,
      sucursalOrigenUuid,
      sucursalDestinoUuid,
      servicioV3Uuid
    ).subscribe(
      (resp) => this.crearViajeNoComercialV3Success(resp),
      (error) => this.crearViajeNoComercialV3Error(error)
    );
  }

  crearViajeNoComercialV3Success(res: any) {
    //console.log({ res })
    this.close();
  }

  crearViajeNoComercialV3Error(error: HttpErrorResponse) {
    //this.enviando = false;
    this.toastr.error((error.error?.msg || '') + (error['requestId'] ? ' Code: ' + error['requestId'] : ''), 'Error', { timeOut: environment.toastErrorTimeout, extendedTimeOut: environment.toastErrorTimeout, closeButton: true, tapToDismiss: false });
  }

  close() {
    this.bsModalRef.hide();
  }


  // Load paraderos from API
  loadParaderos(textoLibre: string = ''): void {
    this.loading = true;
    this.apiService.getListaParaderos(0, 1_000_000, textoLibre).subscribe({
      next: (response) => {
        this.paraderos = response.data.list;
        this.filteredParaderos = [...this.paraderos];
        this.loading = false;
      },
      error: (error) => {
        console.error('Error loading paraderos:', error);
        this.loading = false;
      }
    });
  }

  // Handle search input changes
  onSearchChange(text: string): void {
    this.searchTextChanged.next(text);
  }

  // Search paraderos with API
  searchParaderos(text: string): void {
    if (text.length > 2) {
      this.loadParaderos(text);
    } else if (text.length === 0) {
      this.loadParaderos();
    }
  }

  // Handle origin selection
  onOrigenChange(uuid: string): void {
    this.origenUuid = uuid;
    // Prevent selecting the same paradero for both origin and destination
    if (this.destinoUuid === uuid) {
      this.destinoUuid = '';
    }
  }

  // Handle destination selection
  onDestinoChange(uuid: string): void {
    this.destinoUuid = uuid;
    // Prevent selecting the same paradero for both origin and destination
    if (this.origenUuid === uuid) {
      this.origenUuid = '';
    }
  }

  // Get paradero name by UUID
  getParaderoName(uuid: string): string {
    const paradero = this.paraderos.find(p => p.uuid === uuid);
    return paradero ? `${paradero.nombre} (${paradero.visibleId})` : '';
  }

  // Handle trip type change
  onTripTypeChange(tripType: string): void {
    this.selectedTripType = tripType;
  }

  // Check if a trip type is selected
  isTripTypeSelected(tripType: string): boolean {
    return this.selectedTripType === tripType;
  }

  // Create trip
  crearViaje(): void {
    if (!this.origenUuid || !this.destinoUuid) {
      this.toastr.warning('Debe seleccionar origen y destino', 'Aviso', { timeOut: environment.toastWarningTimeout, extendedTimeOut: environment.toastWarningTimeout, closeButton: true, tapToDismiss: false });
      return;
    }

    const viajeData = {
      esComercial: this.selectedTripType === this.tripTypes.COMERCIAL,
      paraderoUuidOrigen: this.origenUuid,
      paraderoUuidDestino: this.destinoUuid,
      fechaInicio: this.fechaInicio,
      horaInicio: this.horaInicio,
      horaTermino: this.horaTermino,
      sentido: this.sentido
    };

    this.apiService.crearViaje(viajeData).subscribe({
      next: (response) => {
        if (response.success) {
          // this.alertService.presentAlertaInfo(response.msg);
          this.toastr.success(response.msg, '', { timeOut: environment.toastSuccessTimeout, extendedTimeOut: environment.toastSuccessTimeout, closeButton: true, tapToDismiss: false });

          this.eventService.publish('CREAR_VIAJE_CONDUCTORES_EVENT');
          this.cerrarModal()
        } else {
          this.toastr.warning(response.msg || 'Error al crear el viaje', 'Aviso', { timeOut: environment.toastWarningTimeout, extendedTimeOut: environment.toastWarningTimeout, closeButton: true, tapToDismiss: false });
        }
      },
      error: (error: HttpErrorResponse) => {
        this.toastr.error((error.error?.msg || '') + (error['requestId'] ? ' Code: ' + error['requestId'] : ''), 'Error', { timeOut: environment.toastErrorTimeout, extendedTimeOut: environment.toastErrorTimeout, closeButton: true, tapToDismiss: false });
      }
    });
  }

  // Close the modal
  cerrarModal(): void {
    this.bsModalRef.hide();
  }

  incrementTime(campo: string): void {
    const timeStr = this.horas[campo] || '00:00';
    const [hours, minutes] = timeStr.split(':').map(Number);

    let newMinutes = minutes + 5;
    let newHours = hours;

    if (newMinutes >= 60) {
      newMinutes = newMinutes % 60;
      newHours = (newHours + 1) % 24;
    }

    this.horas[campo] = `${newHours.toString().padStart(2, '0')}:${newMinutes.toString().padStart(2, '0')}`;
  }

  decrementTime(campo: string): void {
    const timeStr = this.horas[campo] || '00:00';
    const [hours, minutes] = timeStr.split(':').map(Number);

    let newMinutes = minutes - 5;
    let newHours = hours;

    if (newMinutes < 0) {
      newMinutes = 60 + newMinutes;
      newHours = (newHours - 1 + 24) % 24;
    }

    this.horas[campo] = `${newHours.toString().padStart(2, '0')}:${newMinutes.toString().padStart(2, '0')}`;
  }
}
